import { useEffect, useRef } from "react";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

export default function SNSFeedSection() {
  const { ref, isVisible } = useScrollReveal();
  const fouitaRef1 = useRef<HTMLDivElement>(null);
  const fouitaRef2 = useRef<HTMLDivElement>(null);
  const fouitaRef3 = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!fouitaRef1.current) return;

    const container = fouitaRef1.current;
    if (container.querySelector("#ftyv73gdc")) return;

    const newDiv = document.createElement("div");
    newDiv.setAttribute("data-key", "Instagram Feed ");
    newDiv.setAttribute("class", "ft");
    newDiv.setAttribute("id", "ftyv73gdc");

    const newScript = document.createElement("script");
    newScript.setAttribute("src", "https://wdg.fouita.com/widgets/0x499e29.js");
    newScript.async = true;

    newDiv.appendChild(newScript);
    container.appendChild(newDiv);

    return () => {
      if (container.contains(newDiv)) {
        container.removeChild(newDiv);
      }
    };
  }, []);

  useEffect(() => {
    if (!fouitaRef2.current) return;

    const container = fouitaRef2.current;
    if (container.querySelector("#fths0qtb9")) return;

    const newDiv = document.createElement("div");
    newDiv.setAttribute("data-key", "Instagramフィード");
    newDiv.setAttribute("class", "ft");
    newDiv.setAttribute("id", "fths0qtb9");

    const newScript = document.createElement("script");
    newScript.setAttribute("src", "https://wdg.fouita.com/widgets/0x499e13.js");
    newScript.async = true;

    newDiv.appendChild(newScript);
    container.appendChild(newDiv);

    return () => {
      if (container.contains(newDiv)) {
        container.removeChild(newDiv);
      }
    };
  }, []);

  useEffect(() => {
    if (!fouitaRef3.current) return;

    const container = fouitaRef3.current;
    if (container.querySelector("#ftpqd4wz9j")) return;

    const newDiv = document.createElement("div");
    newDiv.setAttribute("data-key", "カルーセル YouTube ギャラリー");
    newDiv.setAttribute("class", "ft");
    newDiv.setAttribute("id", "ftpqd4wz9j");

    const newScript = document.createElement("script");
    newScript.setAttribute("src", "https://wdg.fouita.com/widgets/0x499e39.js");
    newScript.async = true;

    newDiv.appendChild(newScript);
    container.appendChild(newDiv);

    return () => {
      if (container.contains(newDiv)) {
        container.removeChild(newDiv);
      }
    };
  }, []);

  return (
    <section className="py-3 md:py-6 px-3 md:px-6 lg:px-8 bg-[#f0efef]">
      <div className="max-w-7xl mx-auto bg-white rounded-[20px] overflow-hidden">
        <div className="p-4 md:p-8 lg:p-10">
          <div ref={ref} className={getRevealClass(isVisible)}>
            <div className="text-center mb-6 md:mb-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-black tracking-tight mb-1">
                Instagram
              </h2>
              <div className="w-8 h-px bg-black mx-auto" />
            </div>
          </div>

          {/* OL COMPANY Inc. */}
          <div className="mb-6 md:mb-8">
            <div className="flex items-center gap-3 mb-4 md:mb-5">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 flex items-center justify-center">
                <i className="ri-instagram-line text-white text-lg md:text-xl" />
              </div>
              <div>
                <p className="text-sm font-bold text-black">OL COMPANY Inc.</p>
                <p className="text-xs text-gray-400">@olcompany_inc</p>
              </div>
              <a
                href="https://www.instagram.com/olcompany_inc/"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-auto text-xs font-semibold text-blue-500 hover:text-blue-600 whitespace-nowrap"
              >
                フォローする
              </a>
            </div>
            {/* Fouita Instagram Feed Widget - @olcompany_inc */}
            <div ref={fouitaRef1} className="w-full" />
          </div>

          {/* 森祐作 */}
          <div className="mb-10 md:mb-12">
            <div className="flex items-center gap-3 mb-4 md:mb-5">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 flex items-center justify-center">
                <i className="ri-instagram-line text-white text-lg md:text-xl" />
              </div>
              <div>
                <p className="text-sm font-bold text-black">森祐作</p>
                <p className="text-xs text-gray-400">@yusaku1128</p>
              </div>
              <a
                href="https://www.instagram.com/yusaku1128/"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-auto text-xs font-semibold text-blue-500 hover:text-blue-600 whitespace-nowrap"
              >
                フォローする
              </a>
            </div>
            {/* Fouita Instagram Feed Widget - @yusaku1128 */}
            <div ref={fouitaRef2} className="w-full" />
          </div>

          {/* YouTube Section */}
          <div className="pt-8 md:pt-10 border-t border-gray-200">
            <div className="text-center mb-6 md:mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-black tracking-tight mb-1">
                YouTube
              </h3>
              <p className="text-sm text-gray-400">
                <i className="ri-youtube-line mr-1" />
                @O.L.C
              </p>
            </div>
            {/* Fouita YouTube Carousel Widget - iframe embed */}
            <iframe
              src="https://emb.fouita.com/widget/0x499e39/ftpqd4wz9j"
              title="カルーセル YouTube ギャラリー"
              width="100%"
              height="500"
              frameBorder="0"
              className="w-full rounded-lg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}